export const guideSteps = [
  {
    id: 'step-01',
    step: '01',
    title: '先认准官方首页入口',
    duration: '约 1 分钟',
    desc: '打开本站首页即进入导航总览，先记住首页入口的位置。把页面加入书签后，之后无论换设备还是换浏览器都能一键回到起点，不必反复搜索关键词。',
    points: ['首页入口是全站总枢纽', '建议添加浏览器书签', '换设备后同样通用'],
  },
  {
    id: 'step-02',
    step: '02',
    title: '用主题分类缩小范围',
    duration: '约 2 分钟',
    desc: '如果你只关心某一个方向，直接进入「热门话题」的分类视图，按娱乐、科技、财经等筛选，比在大厅里逐条翻更高效，命中率也更高。',
    points: ['分类视图支持关键词筛选', '可按热度或时间排序', '常看的分类可单独收藏'],
  },
  {
    id: 'step-03',
    step: '03',
    title: '通过热度榜找到正在发酵的话题',
    duration: '约 2 分钟',
    desc: '热门讨论区按互动速度与跟帖深度排序，适合想快速了解「今天大家在讨论什么」的用户。热度榜每小时更新，可以隔一段时间回来查看变化。',
    points: ['热度榜每小时刷新', '跟帖密度高的话题更靠前', '适合快速扫读与选读'],
  },
  {
    id: 'step-04',
    step: '04',
    title: '订阅更新，减少重复搜索',
    duration: '约 1 分钟',
    desc: '如果你不想每天主动查找，可以在页脚填写邮箱订阅每周更新汇总。每周一次、只发重点，不刷屏，很多老用户都用这种方式保持跟进。',
    points: ['每周一封汇总邮件', '只推送重点内容', '可随时取消订阅'],
  },
];

export const accessTips = [
  {
    id: 'tip-01',
    icon: 'ri-shield-check-line',
    title: '核对信息来源',
    desc: '遇到只有单一来源的爆料时先保持观望，等内容出现交叉印证再下判断。',
  },
  {
    id: 'tip-02',
    icon: 'ri-time-line',
    title: '看完整时间线',
    desc: '把相关帖子按时间顺序读完，比只看最新一条更能避免被截取的片段误导。',
  },
  {
    id: 'tip-03',
    icon: 'ri-bookmark-3-line',
    title: '收藏常用入口',
    desc: '把首页与常看的分类页收藏起来，日常访问效率会明显提升。',
  },
  {
    id: 'tip-04',
    icon: 'ri-emotion-happy-line',
    title: '理性参与讨论',
    desc: '表达观点时尽量区分事实与推测，让讨论区保持可读、可回溯。',
  },
];